export function registerTo(application) {
	const controllerModules = [
		[
			"payments-card",
			import(
				/* webpackChunkName: "controller-payments-card" */
				"./payments-card.js"
			),
		],
		[
			"payments-subscription",
			import(
				/* webpackChunkName: "controller-payments-subscription" */
				"./payments-subscription.js"
			),
		],
		[
			"register",
			import(
				/* webpackChunkName: "controller-register" */
				"./register.js"
			),
		],
		[
			"search",
			import(
				/* webpackChunkName: "controller-search" */
				"./search.js"
			),
		],
		[
			"send-mail",
			import(
				/* webpackChunkName: "controller-send-mail" */
				"./send-mail.js"
			),
		],
		[
			"sent-bill",
			import(
				/* webpackChunkName: "controller-sent-bill" */
				"./sent-bill.js"
			),
		],
	];
	return Promise.allSettled(
		controllerModules.map(async ([identifier, fetchingModule]) => {
			const Controller = (await fetchingModule).default;
			application.register(identifier, Controller);
		})
	);
}